/**
 * The trust boundary (engine-interface.md §Reducer). Callers (replay-runner,
 * game-validator, sims) use `validateAndReduceGameState`; never call appliers
 * directly on untrusted input.
 */
import { applyAction } from "./appliers";
import type { AugmentedWarAction } from "./types/action";
import type { AugmentedWarState } from "./types/game-state";
import { validateAction } from "./validators";

export interface ReduceResult {
  readonly state: AugmentedWarState;
  readonly accepted: boolean;
  readonly error?: string;
}

/** Apply WITHOUT validating — only for already-trusted actions. */
export function reduceGameState(
  state: AugmentedWarState,
  action: AugmentedWarAction,
): AugmentedWarState {
  return applyAction(state, action);
}

/** Validate, then apply. Returns the unchanged state + error if rejected. */
export function validateAndReduceGameState(
  state: AugmentedWarState,
  action: AugmentedWarAction,
): ReduceResult {
  const validation = validateAction(state, action);
  if (!validation.valid) {
    return { state, accepted: false, error: validation.error };
  }
  return { state: reduceGameState(state, action), accepted: true };
}
